import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import Header from "../../../components/Header";
import Firebase from "../../../firebasehelper";
import "./index.css";

const Categories = () => {
  const location = useLocation();
  const history = useHistory();
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data) {
          setBrandData(brand_data);
          setLoading(false);
        }
      });
    }
  }, [location]);

  return (
    <div id="page-container" className="ticket-type-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      <main id="main-container">
        {loading && (
          <div className="loading">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
        {!loading && <div className="ticket-type-content"></div>}
      </main>
    </div>
  );
};

export default Categories;



// WEBPACK FOOTER //
// ./src/screens/Tasks/Categories/index.js